import React, { useEffect } from "react";
import { cidt } from "../../json/cidt";
import "./cidt.css";

const Cidt = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container cidt-container">
      <div className="row">
        <div className="col_12">
          <div className="cidt_title">
            <h1>
              Centro de Innovación y Desarrollo Tecnológico del Valle del
              Mezquital
            </h1>
          </div>
        </div>
      </div>
      <div className="row">
        {cidt.map((item) => (
          <div>
            <h2>
              ¿Que es el Centro de Innovación y Desarrollo Tecnológico del Valle
              del Mezquital?
            </h2>
            {item.encabezado.map((header)=>
            <div>
              <p>{header.header}</p>              
            </div>
            )}
            <div className="row">
            {item.silde.map((slide)=> 
              <div className="col-md-4">
                <img src={slide.img} alt=""/>
              </div>
            ) }
            </div>
          </div>
        ))}
        <div className="row">
        {cidt.map((item) => (
          <div>
            <p> {item.parrafo} </p>
            <div className="row">
            {item.objetivos.map((objetivos)=> 
              <div className="col-md-4">
                <img src={objetivos.icon} alt=""/>
                <p> {objetivos.objetivo} </p>
              </div>
            ) }
             <div className="row">
            {/* {item.slidee.map((slidee)=> 
              <div className="col-md-3">
                <img className= "cidt-img" src={slidee.img_slidee} alt=""/>
              </div>

            ) } */}
            <img className= "cidt-img" src=" /img/Cidt/cidt2.png"/>
          
           <p>El CIDT forma parte de la red de 8 plataformas del CIMMYT denominada “Valles Altos”, ubicadas en los Estados de Hidalgo, México y Puebla. Estas plataformas contribuyen a mejorar la vida de los productores desarrollando investigación agrícola para combatir la pobreza por carencia alimentaria, la desnutrición, el cambio climático y la degradación del medio ambiente.</p>

             <h2>
             ¿Cómo Funciona?
             </h2>
             <p>A través de un protocolo de investigación conocido como “Hub” compuesto por 1 plataforma experimental, 8 módulos y áreas de extensión, integradas por 628 hectáreas a la fecha. Este tipo de investigación, permite validar diferentes prácticas y tecnologías agronómicas en beneficio de los agricultores, a través de sus módulos demostrativos y áreas de extensión e impacto.</p>
             <p>Por medio de comités integrados por investigadores, técnicos y productores y en función a los intereses y problemática de los agricultores de la región se definen los intereses de investigación para su posterior validación.</p>
             <h2>
             Las prácticas y sistemas que se validan en el CIDT
             </h2>
             <p> ✓ Están basadas en la Agricultura de Conservación.</p>
             <p>✓ Se enfocan en las necesidades de los productores de la región.</p>
             <p>✓ Se orientan a mejorar la productividad, rentabilidad y sustentabilidad de los sistemas de producción.</p>
             <p>✓ Son accesibles y relevantes para los productores del Estado.</p>   
             <h2>
             ¿Cómo se Vincula?
             </h2>
             <p>✓ Por medio de convenios de colaboración.</p>
             <p>✓ Por medio de peticiones directas para apoyo con asesorías, visitas técnicas, cursos y conferencias.</p>
             <p>✓ Y por medio de la presentación de los resultados en materia de investigación y boletines que se publican periódicamente.</p>
             <p>El objetivo de la vinculación es interactuar con todos los actores que participan, formado una red que es clave en el proceso de investigación, validación, innovación y transferencia de nuevas tecnologías agronómicas que impacten en rendimientos más altos y sustentables en la producción de granos.</p> 
             <h2>Transferencia de Tecnología</h2>
             <p>Transferir en beneficio de los productores agrícolas, los conocimientos, prácticas y tecnologías que se generaron y validaron en la plataforma, es la tarea más importante del CIDT. La aplicación de las innovaciones y metodologías validadas comienzan en los módulos de la plataforma y continúan en las áreas de extensión formadas por 628 hectáreas, para posteriormente replicarse en las áreas de impacto en distintas regiones del Estado, atendiendo su vocación productiva.</p>
             <h2>Servicios a la población</h2>
             <p>El CIDT a través de la SADERH ha establecido un catálogo de servicios en favor de los productores agrícolas del Estado, con el objetivo de eficientar los procesos agrícolas, siendo mas productivos con la aplicación de las nuevas prácticas agronómicas validadas.</p>
             <img className= "cidt-img" src=" /img/Cidt/cidt6.png"/>
            </div>
             
            </div>
          </div>
          

        ))}
      </div>
      
      </div>
      




    </div>
  );
};

export default Cidt;
